import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    PSAT_MATH_LIST_START: "PSAT_MATH_LIST_START",
    PSAT_MATH_LIST_SUCCESS: "PSAT_MATH_LIST_SUCCESS",
    PSAT_MATH_LIST_FAILED: "PSAT_MATH_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const psatMathListStart = (data) => ({
    type: actionType.PSAT_MATH_LIST_START,
    payload: data,
});

export const psatMathListSuccess = (data) => ({
    type: actionType.PSAT_MATH_LIST_SUCCESS,
    payload: data,
});

export const psatMathListFailed = (data) => ({
    type: actionType.PSAT_MATH_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function psatMathListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.PSAT_MATH_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.PSAT_MATH_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.PSAT_MATH_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* psatMathListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allPSATMath =  response.data.data.allPsatmaths.Psatmaths
            yield put(psatMathListSuccess(allPSATMath));
        } else {
            messagePopup("", "PSAT Math List failed", "error");
            yield put(psatMathListFailed("PSAT Math List failed"));
        }
    } catch (error) {
        messagePopup("", "PSAT Math failed", "error");
        yield put(psatMathListFailed("PSAT Math List failed"));
    }
}

export function* watchPsatMathListSaga() {
    yield takeEvery(actionType.PSAT_MATH_LIST_START, psatMathListSaga);
}
